import styled from "@emotion/styled";
import { PageWithTitle } from "src/Common";
import { useQuery } from "react-query";
import { ExchangeAssetsTable } from "./ExchangeAssetsTable";
import { getExchanges } from "src/Api";
import { EXCHANGES } from "src/Api/endpoints";

export const AssetCatalog = () => {
  const { data: exchanges } = useQuery(EXCHANGES, getExchanges);

  return (
    <PageWithTitle>
      <GridContainer>
        <ExchangeAssetsTable rows={exchanges ?? []} />
      </GridContainer>
    </PageWithTitle>
  );
};

const GridContainer = styled.div({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "1rem",
});
